import React from 'react'
import Image from 'next/image'
import { StaticImageData } from 'next/image'
import Trans from 'next-translate/Trans'
import {
  HeroRoot,
  ImageWrapper,
  ImageColumn,
  HeroBox,
  Header,
  Subheader,
  CopyColumn,
} from './Hero.styles'

type HeroProps = {
  title: string
  subtitle: string
  heroImage: StaticImageData
  imageAlt: string
}

export const Hero = (props: HeroProps) => {
  const { title, subtitle, heroImage, imageAlt } = props
  return (
    <HeroRoot role="banner">
      <HeroBox>
        <ImageColumn>
          <ImageWrapper>
            <Image objectFit="cover" layout="fill" src={heroImage} alt={imageAlt} />
          </ImageWrapper>
        </ImageColumn>
        <CopyColumn>
          <Header>
            <Trans i18nKey={title} components={{ br: <br /> }} />
          </Header>
          <Subheader>
            <Trans i18nKey={subtitle} />
          </Subheader>
        </CopyColumn>
      </HeroBox>
    </HeroRoot>
  )
}

Hero.displayName = 'Hero'
